module.exports = __webpack_public_path__ + "grey-bg.jpg?680b08f4225aeefac313c3fb6d898fd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grey-bg.jpg
// module id = 13
// module chunks = 0